import React from 'react'
import { getFeatureFromCache } from '../../../../../util/feature-cache'
import { FEATURE_UC_IN_WEBREGISTER_LOCK_ICON } from '../../../../../constants'
import { PromoCodeLabelProps } from './usePromoCodeLabelModel'

import { PromoCodeLabel as PromoCodeLabelUnified } from './PromoCodeLabel'
import { PromoCodeLabelLegacy } from './PromoCodeLabelLegacy'

export const PromoCodeLabel: React.FC<PromoCodeLabelProps> = props => {
  const isUnifiedEnabled = getFeatureFromCache(
    FEATURE_UC_IN_WEBREGISTER_LOCK_ICON
  )

  return isUnifiedEnabled ? (
    <PromoCodeLabelUnified {...props} />
  ) : (
    <PromoCodeLabelLegacy {...props} />
  )
}
